import React from "react";
import { IPackage } from "pages/Packages/List/api";
import { IPackageItem } from "../../api";
import { ViewDetails } from "../../../../../components/ViewDetails";
import { PackageItemsList } from "components/PackageItemsList";
import { StatusMessage } from "components/StatusMessage";

import "./index.css";

interface Props {
  item: IPackage;
  packageItems: (IPackageItem & { accepted: boolean, rejected: boolean, accepting: boolean, rejecting: boolean })[];
  onAcceptItem: (item: IPackageItem, price: number) => any;
  onRejectItem: (item: IPackageItem) => any;
  onItemPriceChanged: (item: IPackageItem, price: number) => any;
}

export function Reviewed({
  item,
  packageItems,
  onAcceptItem,
  onRejectItem,
  onItemPriceChanged
}: Props) {
  return (
    <div>
      <StatusMessage message="We have finished reviewing your items" actionType="seller"/>
      <PackageItemsList
        packageItems={packageItems}
        showEarnings
        onAcceptItem={onAcceptItem}
        onRejectItem={onRejectItem}
        onItemPriceChanged={onItemPriceChanged}
      />
      <hr/>
      <ViewDetails item={item} />
    </div>
  );
}
